export default __webpack_public_path__ + "static/media/icon-fashion.9258184a.png";